import { ProgressBar } from "@stacklet/ui";

import { useAlertContext } from "app/contexts";

import { useCsvExportProgress } from "./useCsvExportProgress";

import type { ExportConnectionInput } from "app/mutations/__generated__/ExportConnectionMutation.graphql";

interface Props {
  nodeId?: string | null;
  field: string;
  columns: readonly { name: string; path: string; subpath?: string }[];
  markComplete?: () => void;
  rowCount: number;
  params?: ExportConnectionInput["params"];
  extraPaths?: ExportConnectionInput["extraPaths"];
  exportInProgress: boolean;
}

export function ExportCsv({
  nodeId,
  field,
  columns,
  exportInProgress,
  markComplete,
  rowCount,
  params,
  extraPaths,
}: Props) {
  const { alertDispatch } = useAlertContext();
  const { showProgress, percentage } = useCsvExportProgress({
    columns,
    exportInProgress,
    extraPaths,
    field,
    nodeId,
    onComplete: markComplete,
    onError: (message) => alertDispatch({ message, severity: "error" }),
    params,
    rowCount,
  });

  if (!showProgress) {
    return null;
  }

  return (
    <ProgressBar label="File export in progress." percentage={percentage} />
  );
}
